import * as z from "zod";

export const getGoogleAdsCustomers = {
  name: "getGoogleAdsCustomers" as const,
  input: z.null(),
  output: z.object({
    customers: z.array(z.object({ customerId: z.string(), name: z.string() })),
  }),
};
